/**
 * @generated SignedSource<<7d70d7ad635d9125966c64cae2e966d1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_datasetExampleToEvaluatorInput_example$data = {
  readonly input: any;
  readonly metadata: any;
  readonly output: any;
  readonly " $fragmentType": "utils_datasetExampleToEvaluatorInput_example";
};
export type utils_datasetExampleToEvaluatorInput_example$key = {
  readonly " $data"?: utils_datasetExampleToEvaluatorInput_example$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_datasetExampleToEvaluatorInput_example">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utils_datasetExampleToEvaluatorInput_example"
};

(node as any).hash = "2bc657d55c240986265a3810deb4eef4";

export default node;
